export const ADMIN_SCREENSHOT_MODE_STORAGE_KEY = "HC_ADMIN_SCREENSHOT_MODE";

/**
 * Browser drivers (e2e, acceptance runs): set localStorage
 * `HC_ADMIN_HIDE_DEV_CHROME` to "true" to hide the floating localhost dev
 * chrome, which can sit over lower-right cells, without screenshot mode's CRM
 * fixtures. Nothing else changes; production never shows dev chrome.
 */
export const ADMIN_HIDE_DEV_CHROME_STORAGE_KEY = "HC_ADMIN_HIDE_DEV_CHROME";

const isLocalDevChromeHidden = (): boolean => {
  try {
    return (
      window.localStorage.getItem(ADMIN_HIDE_DEV_CHROME_STORAGE_KEY) === "true"
    );
  } catch {
    return false;
  }
};

export const isAdminScreenshotModeEnabled = (): boolean => {
  if (import.meta.env.VITE_SCREENSHOT_MODE === "true") {
    return true;
  }

  try {
    const stored = window.localStorage.getItem(
      ADMIN_SCREENSHOT_MODE_STORAGE_KEY,
    );
    return stored === "true" || stored === "1";
  } catch {
    return false;
  }
};

/**
 * Keeps floating localhost chrome off routes that own a full-screen shell.
 */
export const shouldShowLocalDevChrome = (pathname: string): boolean => {
  if (isAdminScreenshotModeEnabled() || isLocalDevChromeHidden()) {
    return false;
  }

  if (
    pathname === "/" ||
    pathname === "/login" ||
    pathname.startsWith("/share/docs/")
  ) {
    return false;
  }

  return !pathname.startsWith("/v2");
};

/**
 * In eligible non-production environments, safety badges stay visible across
 * the real admin shell because they communicate production-backed risk.
 */
export const shouldShowGlobalEnvironmentSafetyChrome = (
  pathname: string,
): boolean => {
  if (isAdminScreenshotModeEnabled()) {
    return false;
  }

  if (pathname === "/login" || pathname.startsWith("/share/docs/")) {
    return false;
  }

  return true;
};
